/**
 * Project views
 * Path: `@/views/project`
 * - Project's edm views: used for document's managment
 * - Company settings views: handle company settings
 * - Project's inspection views
 * - Project's nonconformity views
 */

import multiguard from "vue-router-multiguard"
import { requireAuth, requireCompany, requireProject } from "@/utils/middleware"

const General = () => import("@/views/project/General.vue")
const ProjectCreateUpdate = () => import("@/views/project/ProjectCreateUpdate.vue")
const Projects = () => import("@/views/project/Projects.vue")
const ProjectTeam = () => import("@/views/project/ProjectTeam.vue")
const ReservationsCalendar = () => import("@/views/project/ReservationsCalendar.vue")

const AllInspections = () => import("@/views/project/inspection/AllInspections.vue")

const Customers = () => import("@/views/project/customer/Customers.vue")
const CustomerCreateUpdate = () => import("@/views/project/customer/CustomerCreateUpdate.vue")

const Reservations = () => import("@/views/project/reservation/Reservations.vue")
const ReservationCreateUpdate = () =>
  import("@/views/project/reservation/ReservationCreateUpdate.vue")

const AllActions = () => import("@/views/project/nonconformity/AllActions.vue")
const AllCustomers = () => import("@/views/project/customer/AllCustomers.vue")
const AllReservations = () => import("@/views/project/reservation/AllReservations.vue")

// DRAWERS
const ProjectDrawer = () => import("@/components/layouts/core/ProjectDrawer.vue")
const SpaceDetail = () => import("@/views/project/space/SpaceDetail.vue")
const AuthorisationDetail = () => import("@/views/project/authorisation/AuthorisationDetail.vue")
const Financial = () => import("@/views/project/Financial.vue")

export default [
  {
    path: "/inspections",
    name: "AllInspections",
    component: AllInspections,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/customers",
    name: "AllCustomers",
    component: AllCustomers,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/reservations",
    name: "AllReservations",
    component: AllReservations,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/non-conformities/actions",
    name: "AllActions",
    component: AllActions,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/projects/list",
    name: "Projects",
    component: Projects,
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/projects/:id?/editor",
    name: "ProjectCreateUpdate",
    component: ProjectCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/project/bilan",
    name: "Financial",
    component: Financial,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/home",
    name: "Project",
    component: General,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/calendar",
    name: "ReservationsCalendar",
    component: ReservationsCalendar,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/team",
    name: "ProjectTeam",
    component: ProjectTeam,
    beforeEnter: multiguard([requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/event/customers",
    name: "Customers",
    component: Customers,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/event/customers/:id?/editor",
    name: "CustomerCreateUpdate",
    component: CustomerCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/event/resevations",
    name: "Reservations",
    component: Reservations,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/event/resevations/:id?/editor",
    name: "ReservationCreateUpdate",
    component: ReservationCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/event/configuration",
    component: SpaceDetail,
    name: "SpaceDetail",
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/event/autorisation",
    component: AuthorisationDetail,
    name: "AuthorisationDetail",
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  }
]
